module.exports = "<div class=\"am4-login__content\">\n  <p>{{'SUCCESS_PASSWORD_RESET' | translate}}</p>\n\n  <a class=\"am4-login__submit\" ui-sref=\"app.login({email: success.email})\">{{'LOG_IN' | translate}}</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/forgot/reset/success.html
// module id = 169
// module chunks = 14